const views = Object.freeze({today:"today", closed: "closed", future: "future"});

export default views;